import React from "react";
import { useFormikContext } from "formik";

import LayerCard from "../elements/LayerCard";
import RadioCardGroup from "../../../shared/RadioCardGroup";
import type { L3Context, TargetFormValues } from "../TargetBuilderPanel.types";
import { useLModelCascade } from "../hooks/useLModelCascade";

/**
 * L3 — Instructional Context picker.
 * Options are filtered by current L2. Selecting a context unlocks the
 * teaching-procedure block (Section 2.5).
 */
const L3ContextSelector: React.FC = () => {
  const { values } = useFormikContext<TargetFormValues>();
  const { l3Options, setL3 } = useLModelCascade();

  if (!values.l2_method) return null;

  return (
    <LayerCard
      title="What is the teaching or intervention approach?"
      description="Select the instructional framework for this target"
    >
      <RadioCardGroup<L3Context>
        ariaLabel="Instructional context"
        value={values.l3_context}
        options={l3Options}
        onChange={setL3}
      />
    </LayerCard>
  );
};

export default L3ContextSelector;
